export class ConstantsUtil {
    static readonly text = {
        ALGORITHM:"Algorithm",
        VERSIONS:"Versions",
        SELECT_ALGORITHM:"Select Algorithm",
        SELECT_VERSION:"Select Version",
        INTELLEGENT_ADVISOR:"Intelligent Advisor",
        NOTE:"Note: select from the available list of Algorithm."
    }
}